export type Device = {
  name: string;
  width: string;
  height: string;
};

export const customDevice: Device = { name: "Custom", width: "0px", height: "0px" };

export const devices: Device[] = [
  customDevice,
  { name: "iPad", width: "768px", height: "1024px" },
  { name: "iPad Pro", width: "1024px", height: "1366px" },
  { name: "iPhone 8", width: "375px", height: "667px" },
  { name: "iPhone X", width: "375px", height: "812px" },
  { name: "iPhone 11", width: "276px", height: "598px" },
  { name: "iPhone 12", width: "390px", height: "844px" },
  { name: "iPhone 15", width: "393px", height: "852px" },
];
